import shouldForwardProp from "@styled-system/should-forward-prop";
import {
  visibilityProp,
  VisibilityProps,
  BackgroundProps,
  background,
  cursorProp,
  CursorProp,
  compose,
  space,
  layout,
  border,
  flexbox,
  position,
  typography,
  color,
  shadow,
  SpaceProps,
  LayoutProps,
  BorderProps,
  FlexboxProps,
  PositionProps,
  TypographyProps,
  ColorProps,
  ShadowProps,
  OverrideNativeElementProps,
  textTransformProp,
  TextTransformProp,
  FloatProps,
  float,
} from "../../utils/styleFn";
import { styled, EmotionComponent } from "../../styled";

export const boxStyleProps = compose(
  visibilityProp,
  cursorProp,
  space,
  layout,
  background,
  position,
  color,
  typography,
  shadow,
  border,
  flexbox,
  textTransformProp,
  float
);

export type BoxProps = OverrideNativeElementProps<
  VisibilityProps &
    SpaceProps &
    BackgroundProps &
    FlexboxProps &
    LayoutProps &
    BorderProps &
    PositionProps &
    TypographyProps &
    ColorProps &
    ShadowProps &
    CursorProp &
    TextTransformProp &
    FloatProps,
  "div"
>;

export const Box: EmotionComponent<BoxProps> = styled("div", {
  shouldForwardProp,
})`
  ${boxStyleProps}
`;

Box.displayName = "Box";

export default Box;
